import { motion } from 'framer-motion';
import QRScreen from '../../screens/ProfileUser/QRScreen';

/**
 * QROverlay — Thin animation shell for QR screen
 *
 * Mounted-but-hidden pattern: stays in DOM always for Profile users.
 * When hidden: visibility:hidden, pointer-events:none (no re-initialization on toggle).
 * Framer Motion slides it up from bottom when opening, down when closing.
 */
const QROverlay = ({ isOpen, onClose }) => {
  return (
    <motion.div
      initial={{ y: '100%', opacity: 0, visibility: 'hidden' }}
      animate={
        isOpen
          ? { y: 0, opacity: 1, visibility: 'visible' }
          : { y: '100%', opacity: 0, transitionEnd: { visibility: 'hidden' } }
      }
      transition={{
        type: 'tween',
        duration: 0.75,
        ease: [0.32, 0.72, 0, 1],
      }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000,
        pointerEvents: isOpen ? 'auto' : 'none',
      }}
    >
      <QRScreen isOpen={isOpen} onClose={onClose} />
    </motion.div>
  );
};

export default QROverlay;
